import { cloudApi } from './http.js'

function runsPath(tenantId, projectId) {
  return `/api/tenants/${encodeURIComponent(tenantId)}/projects/${encodeURIComponent(projectId)}/market-analysis-runs`
}

export const marketAnalysisApi = Object.freeze({
  history(tenantId, projectId, options = {}) {
    const { compact = false, ...requestOptions } = options
    const path = `/api/tenants/${encodeURIComponent(tenantId)}/marketing-projects/${encodeURIComponent(projectId)}/market-reports`
    return cloudApi.get(`${path}${compact ? '?compact=true' : ''}`, { ...requestOptions, timeoutMs: options.timeoutMs || 30_000 })
  },
  current(tenantId, projectId, options = {}) {
    const { compact = false, ...requestOptions } = options
    return cloudApi.get(`${runsPath(tenantId, projectId)}/current${compact ? '?compact=true' : ''}`, requestOptions)
  },
  report(tenantId, projectId, reportId, options = {}) {
    return cloudApi.get(`/api/tenants/${encodeURIComponent(tenantId)}/marketing-projects/${encodeURIComponent(projectId)}/market-reports/${encodeURIComponent(reportId)}`, options)
  },
  byRequest(tenantId, projectId, key, options = {}) {
    const query = new URLSearchParams({ compact: 'true', idempotency_key: key })
    return cloudApi.get(`${runsPath(tenantId, projectId)}/current?${query}`, options)
  },
  get(tenantId, projectId, runId) {
    return cloudApi.get(`${runsPath(tenantId, projectId)}/${encodeURIComponent(runId)}`)
  },
  create(tenantId, projectId, body, options = {}) {
    return cloudApi.post(runsPath(tenantId, projectId), body, options)
  },
  stop(tenantId, projectId, runId) {
    return cloudApi.post(`${runsPath(tenantId, projectId)}/${encodeURIComponent(runId)}:stop`, null)
  },
  retryFailed(tenantId, projectId, runId, options = {}) {
    const { recollectUnsaved = false, ...requestOptions } = options
    return cloudApi.post(
      `${runsPath(tenantId, projectId)}/${encodeURIComponent(runId)}:retry-failed${recollectUnsaved ? '?recollect_unsaved=true' : ''}`,
      null,
      requestOptions,
    )
  },
  eventsPath(tenantId, projectId, runId) {
    return `${runsPath(tenantId, projectId)}/${encodeURIComponent(runId)}/events`
  },
})
